module.exports = __webpack_public_path__ + "img/23.6d883b96.png";